module.exports = __webpack_public_path__ + "img/2.e0d0549c.jpg";